import { styled } from '@acko-tech/building-blocks.ui.common';
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme';

export const Label = styled.div`
  position: absolute;
  background-color: #ffffff;
  font-size: ${() => AckoMainTheme.typography.fonts.size.P2};
  left: 12px;
  top: -8px;
  padding: 0 4px;
  color: ${() => AckoMainTheme.colors.light.neutral.n400};
`;

export const InFocusInput = styled.div`
  display: ${(props) => (props?.open ? 'flex' : 'none')};
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  background: #ffffff;
  border: 1px solid #e7e7f0;
  border-radius: 8px;

  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
  padding: 14px 12px;
  max-height: 110px;
  overflow: auto;
`;

export const SearchPage = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
  width: 100%;
  height: ${(props) => (props.isDesktop ? '250px' : 'calc(100vh - 240px)')};
  overflow: scroll;
`;

export const Note = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  font-style: normal;
  color: rgb(91, 86, 117);
  padding: 8px;
  border-radius: 8px;
  margin-top: 16px;
  background: linear-gradient(
    to right,
    rgba(251, 233, 246, 0.68),
    rgba(255, 207, 242, 0.56)
  );
`;

export const DesktopNote = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  font-style: normal;
  color: rgb(91, 86, 117);
  padding: 8px;
  border-radius: 8px;
  margin-top: 8px;
  background: #e2f5ff;
  margin: 0 20px;
  margin-bottom: 20px;
`;

export const SearchInput = styled.input`
  border-radius: 8px;
  border: none;
  background: transparent;
  outline: none;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.P1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.P1};
  line-height: ${() => AckoMainTheme.typography.lineHeights.P1};
  color: ${() => AckoMainTheme.colors.light.neutral.n400};
  display: inline-block;
`;

export const Main = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
  width: 100%;
  cursor: pointer;
`;

export const MobileContainer = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
`;

export const ButtonContainer = styled.div`
  font-style: normal;
  margin-top: ${(props) => props.marginTop || '10px'};
  position: relative;
  cursor: pointer;
  margin: 16px;
`;

export const ButtonLoaderImage = styled.img`
  display: ${(props) => (props.visibility ? 'block' : 'none')};
  width: 65px;
  position: absolute;
  left: 50%;
  margin-top: ${(props) => props.marginTop || '30px'};
  transform: translate(-50%, -50%);
`;

export const ButtonText = styled.div`
  visibility: ${(props) => (props.hide ? 'hidden' : 'unset')};
  font-size: ${(props) =>
    props?.size || AckoMainTheme.typography.fonts.weight.P1};
  font-weight: ${(props) =>
    props?.weight || AckoMainTheme.typography.fonts.size.T1};
  line-height: ${(props) =>
    props?.lineHeight || AckoMainTheme.typography.lineHeights.P2};
  padding: ${(props) => props?.padding || '4px 0'};
`;

export const SelectContainer = styled.div`
  font-style: normal;
  position: relative;
  width: 100%;
  ${(props) => props && props.styles};
`;

export const Blocker = styled.div`
  position: absolute;
  top: 0;
  background: transparent;
  height: 100%;
  width: 100%;
  opacity: 0;
`;

export const BoldText = styled.div`
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.T1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.H4};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T2};
  padding: ${(props) => props?.padding || '30px 0 10px 0'};
`;

export const MobileHeader = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.H1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.H4};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T2};
  padding: ${(props) => props?.padding || '30px 0 10px 0'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 0 20px;
  width: 100%;
`;

export const SelectedItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  row-gap: 8px;
  flex-wrap: wrap;
  // max-height: 110px;
  overflow: auto;
  padding-right: 10px;
`;

export const ItemPill = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  gap: 8px;
  text-transform: capitalize;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.P1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.P2};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T4_M};
  background: #efe9fb;
  border: 1px solid #d0bdf4;
  border-radius: 20px;
`;

export const PopularItemsContainer = styled.div`
  font-style: normal;
  margin-bottom: ${(props) =>
    props.isDesktop || props.removeExtraMargin ? '0' : '100px'};
  position: relative;
`;

export const DesktopDropdownItems = styled.div`
  overflow: auto;
  margin: 20px;
  padding-right: 10px;
  max-height: 320px;
  overflow: auto;

  @media screen and (min-width: 768px) {
    max-height: 264px;
    ::-webkit-scrollbar {
      width: 4px;
      background: rgb(217, 217, 217);
      display: block;
      border-radius: 32px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 32px;
      background: rgb(111, 109, 109);
    }
  }
`;

export const PopularItems = styled.div`
  overflow: auto;
  margin: 0 20px;
  overflow: auto;

  @media screen and (min-width: 768px) {
    max-height: 264px;
    padding-right: 10px;
    ::-webkit-scrollbar {
      width: 4px;
      background: rgba(217, 217, 217, 0.5);
      display: block;
      border-radius: 32px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 32px;
      background: rgba(111, 109, 109, 0.7);
    }
  }
`;

export const ItemCheckbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.justify || 'space-between'};
  gap: 10px;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.P1};
  font-size: 1rem;
  line-height: ${() => AckoMainTheme.typography.lineHeights.T4_M};
  border-bottom: 1px solid #e7e7f0;
  padding: 16px 0px;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    &:first-child {
      padding-top: unset;
    }
  }

  &:last-child {
    border-bottom: unset;
  }
`;

export const SearchContainer = styled.div`
  margin: 0 20px;
  font-style: normal;
  margin-bottom: 16px;
`;

export const SelectedContainer = styled.div`
  font-style: normal;
  margin: 20px;
  margin-top: 5px;
`;

export const TitleIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 5px;
  margin-bottom: -2px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-bottom: ${(props) => props.marginBottom || '20px'};
`;

export const ModalTitle = styled.div`
  width: 100%;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.H1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.T3};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T3};
  margin-top: ${(props) => props.marginTop || '0px'};
  padding-left: ${(props) => props.left || '20px'};
`;
export const SubTitle = styled.div`
  width: 100%;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: ${(props) => props.left || '20px'};
`;

export const SearchItem = styled.div`
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.P1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.T4_M};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T4_M};
  border-bottom: 1px solid #e7e7f0;
  padding: 16px 0;
  padding-left: 10px;
`;

export const DesktopContainer = styled.div`
  color: ${() => AckoMainTheme.colors.light.primary.n600};
  font-style: normal;
  background: #ffffff;
  border: 1px solid #e7e7f0;
  box-shadow: 0px 4px 6px -2px rgba(54, 53, 76, 0.08);
  border-radius: 8px;
  padding-top: 20px;
  position: absolute;
  top: ${(props) => `${props?.height}px` || '58px'};
  z-index: 2;
  width: ${(props) => props?.dropdownWidth || '58px'};
`;

export const ErrorMessage = styled.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.P1};
  font-size: ${() => AckoMainTheme.typography.fonts.size.T3};
  line-height: ${() => AckoMainTheme.typography.lineHeights.T2};
  color: ${() => AckoMainTheme.colors.light.primary.n600};
`;

export const BottomCTA = styled.div`
  box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.1);
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
  border-radius: ${(props) => props?.radius || '0'};
`;

export const DesktopButton = styled.div`
  box-shadow: 0px -4px 8px -2px rgba(54, 53, 76, 0.1);
  width: calc(100% - 1px);
  background: white;
  border-radius: 0 0 8px 8px;
  border-top: unset;
  padding-top: 1px;
`;

export const DropdownContainer = styled.div`
  transform: ${(props) => (props.open ? 'rotate(180deg)' : '')};
  transition: transform 0.2s ease-in-out;
`;

export const RemoveItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0 0 2px;
`;

export const MobileContent = styled.div`
  width: 100%;
  height: ${(props) => (props.isMobile ? 'calc(100vh - 240px)' : '240px')};
  overflow: scroll;
`;

export const DesktopContent = styled.div`
  width: 100%;
`;

export const InputLabelContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 5px;
`;

export const Name = styled.div`
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.25rem;
`;

export const Count = styled.div`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #5b5675;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${() => AckoMainTheme.typography.fonts.size.H1};
  width: 32px;
  height: 24px;
  background: ${(props) =>
    props.hide ? AckoMainTheme.colors.light.neutral.n300 : 'transparent'};
  border-radius: ${(props) => (props.hide ? '4px' : '0')};
  text-align: center;
`;
export const DefaultName = styled.div`
  font-weight: ${() => AckoMainTheme.typography.fonts.weight.T2};
  font-size: ${() => AckoMainTheme.typography.fonts.size.C1};
  color: ${AckoMainTheme.colors.light.neutral.n400};
  text-transform: uppercase;
`;
